
export const getHomePageUrl = () => "/session";

export const getVIPPageUrl = () => "/vip";

export const getEarnPointsPageUrl = () => "/earn-points";